module.exports = __webpack_public_path__ + "static/RADAR First-e9d6831991b485efef971b61a5ecb53c.jpg";